module.exports = "/shifts/components/calendarHeader/pendingApprovalSummaryComponent-aab15f.html";